import GetTokenPage from '.'

const GetTokenAdminPage = props => {
  return <GetTokenPage {...props} impersonate={true} />
}

export default GetTokenAdminPage
